// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yLkJ","rootMobile":"styles_rootMobile__2OU8O"};